export * from './modify-res.component';


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/modify-res/modify-res/index.ts